// src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import PublicHqsWebsite from "./public/PublicHqsWebsite";
import "./index.css";
import "./public/public-ai-future.css";
import { captureFrontendError, initFrontendSentry } from "./lib/sentry";
import { AppProviders } from "./contexts/AppProviders";
import { registerServiceWorker } from "./registerSW";

const normalizedPath = window.location.pathname.replace(/\/+$/, "") || "/";
const isAdminRoute = normalizedPath === "/admin" || normalizedPath.startsWith("/admin/");
const isConsentRoute = normalizedPath === "/oauth/consent";

initFrontendSentry();

window.addEventListener("vite:preloadError", () => {
  const RELOAD_GUARD_KEY = "hqs-stale-chunk-reload-at";
  const lastReloadAt = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || 0);
  if (Date.now() - lastReloadAt > 10_000) {
    sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
    window.location.reload();
  }
});

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("React Error:", error, errorInfo);
    captureFrontendError(error, {
      component: "ErrorBoundary",
      route: isAdminRoute ? "admin" : "public",
      errorInfo: { componentStack: String(errorInfo?.componentStack || "") },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "2rem", textAlign: "center", color: "#e2e8f0", background: "#020711" }}>
          <div style={{ background: "#07111f", padding: "2.5rem", borderRadius: "18px", border: "1px solid rgba(148,163,184,.16)", boxShadow: "0 24px 80px rgba(0,0,0,.42)", maxWidth: "520px" }}>
            <h2 style={{ color: "#f8fafc", marginBottom: "1rem" }}>HQS konnte nicht geladen werden</h2>
            <p style={{ marginBottom: "1.5rem", color: "#94a3b8", lineHeight: 1.65 }}>Es ist ein unerwarteter Frontend-Fehler aufgetreten. Bitte lade die Seite neu.</p>
            <button onClick={() => window.location.reload()} style={{ padding: "0.75rem 1.5rem", background: "#67e8f9", color: "#03111a", border: "none", borderRadius: "10px", cursor: "pointer", fontWeight: "700", fontSize: "0.9rem" }}>Seite neu laden</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {isAdminRoute || isConsentRoute ? (
      <AppProviders><ErrorBoundary><App /></ErrorBoundary></AppProviders>
    ) : (
      <ErrorBoundary><PublicHqsWebsite /></ErrorBoundary>
    )}
  </React.StrictMode>,
);
void registerServiceWorker();
